import { useFerve } from "@features/ferve/FerveProvider"
import { useSnapshot } from "valtio"

export function useCartState() {
  const ferve = useFerve()
  const state = useSnapshot(ferve.cart).state
  return state
}
